export default "__VITE_ASSET__DMHg914G__"